import DebugUANC from '../core/version/debug';

export const isLocalStoreEnabled = (): boolean => {
    try {
        const testKey = 'UANC-test-localStorage';
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        window.Inpl?.Ad?.UANC instanceof DebugUANC && window.Inpl.Ad.UANC.warn('localStorage is not available');
        return false;
    }
};

export const saveToLocalStorage = (key: string, value: any): void => {
    try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
    } catch (e) {
        window.Inpl?.Ad?.UANC instanceof DebugUANC && window.Inpl.Ad.UANC.warn(`Failed to save to localStorage: ${key}`);
    }
};

export const loadFromLocalStorage = <T>(key: string): T | null => {
    try {
        const serializedValue = localStorage.getItem(key);
        if (serializedValue === null) {
            return null;
        }
        return JSON.parse(serializedValue) as T;
    } catch (e) {
        window.Inpl?.Ad?.UANC instanceof DebugUANC && window.Inpl.Ad.UANC.warn(`Failed to loading from localStorage: ${key}`);
        return null;
    }
};

export const removeFromLocalStorage = (key: string): void => {
    try {
        localStorage.removeItem(key);
    } catch (e) {
        window.Inpl?.Ad?.UANC instanceof DebugUANC && window.Inpl.Ad.UANC.warn(`Failed to remove item from localStorage: ${key}`);
    }
};
